import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useLoginAlert } from '@/contexts/LoginAlertContext'
import { NOT_LOGGED_MESSAGE } from '@/hooks/usePurchases'
import { Alert } from '@/components/ui/Alert'
import { Footer } from './Footer'
import { Header } from './Header'
import { HowToWinDialog } from './HowToWinDialog'
import { PromoBanner } from './PromoBanner'

/**
 * Moldura das páginas públicas: cabeçalho, tarja promocional, conteúdo, rodapé
 * e o botão flutuante de "Como concorrer".
 */
export function AppLayout() {
  const { pathname } = useLocation()
  const { visible: loginAlertVisible, hide: hideLoginAlert } = useLoginAlert()

  // Toda navegação começa no topo, e o aviso de login não vaza entre páginas.
  useEffect(() => {
    window.scrollTo(0, 0)
    hideLoginAlert()
  }, [pathname, hideLoginAlert])

  return (
    <div className="flex min-h-dvh flex-col">
      <a
        href="#conteudo"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-surface focus:px-4 focus:py-2 focus:text-sm focus:font-semibold"
      >
        Pular para o conteúdo
      </a>

      <Header />
      <PromoBanner />

      {loginAlertVisible && (
        <Alert tone="danger" centered className="animate-[slide-down_0.18s_ease-out]">
          {NOT_LOGGED_MESSAGE}
        </Alert>
      )}

      <main id="conteudo" className="flex-1">
        <Outlet />
      </main>

      <Footer />
      <HowToWinDialog />
    </div>
  )
}
